<div
  *ngIf="confirmNoMsg"
  class="center">
  <h2 mat-dialog-title>Error al enviar consulta</h2>
  <div mat-dialog-content>
    <p>No pudimos enviar tu consulta, volvé a intentarlo por favor</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>

<div
  *ngIf="confirmSend"
  class="center">
  <h2 mat-dialog-title>Se generó con éxito el número de gestión {{ type?.info?.value }}</h2>
  <div mat-dialog-content>
    <p>Te mantendremos informado por medio del correo registrado en Compra Gamer.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>

<div
  *ngIf="confirmacion_logout"
  class="center">
  <h2 mat-dialog-title>Cierre de sesión</h2>
  <div mat-dialog-content>
    <p>¿Estás seguro que querés cerrar tu sesión?</p>
  </div>
  <div
    mat-dialog-actions
    class="centrado">
    <button
      mat-raised-button
      color="primary"
      class="button-ok-width button-flex"
      [mat-dialog-close]="true">
      Aceptar
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="button-cancel-width button-flex"
      (click)="onNoClick()">
      Cancelar
    </button>
  </div>
</div>

<div
  *ngIf="borrarCarrito"
  class="center">
  <h2 mat-dialog-title>Borrar carrito</h2>
  <div mat-dialog-content>
    <p>¿Estás seguro que querés borrar todos los productos de tu carrito?</p>
  </div>
  <div
    mat-dialog-actions
    class="centrado">
    <button
      mat-raised-button
      color="primary"
      class="button-ok-width button-flex"
      [mat-dialog-close]="true">
      Aceptar
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="button-cancel-width button-flex"
      (click)="onNoClick()">
      Cancelar
    </button>
  </div>
</div>
<div
  *ngIf="promoGame"
  class="promoGame">
  <h2
    mat-dialog-title
    class="orange noMargin">
    Promociones vigentes
  </h2>
  <div mat-dialog-content>
    <ul>
      <li>
        <p>AMD - Assassin´s Creed Valhalla</p>
        <span>Para pedidos con hasta el: 03/10/2020</span>
      </li>
      <li>
        <p>AMD Radeon™ RX 5000 Series = Godfall™ + WoW:S</p>
        <span>Para pedidos con hasta el: 03/10/2020</span>
      </li>
      <li>
        <p>AMD Radeon™ RX 5500 XT = Godfall™</p>
        <span>Para pedidos con hasta el: 03/10/2020</span>
      </li>
      <li>
        <p>GeForce RTX Death Stranding Bundle - Assets</p>
        <span>Para pedidos con hasta el: 29/07/2020</span>
      </li>
      <li>
        <p>NVIDIA GeForce - Bun dle - Shadow of The Tomb Raider</p>
        <span>Para pedidos con hasta el: 31/07/2020</span>
      </li>
    </ul>
  </div>
  <div
    mat-dialog-actions
    class="button">
    <button
      mat-raised-button
      color="primary"
      (click)="onNoClick()">
      Cerrar
    </button>
  </div>
</div>

<div *ngIf="closeGestion">
  <a
    class="closeModal"
    mat-dialog-close>
    <mat-icon>cancel</mat-icon>
  </a>
  <h2
    mat-dialog-title
    class="orange noMargin">
    Cerrar gestión
  </h2>
  <div mat-dialog-content>
    <p>Dejanos un comentario sobre nuestra atención (opcional)</p>
    <textarea
      rows="4"
      [(ngModel)]="comment"></textarea>
  </div>
  <div
    mat-dialog-actions
    class="button">
    <button
      mat-raised-button
      color="primary"
      [mat-dialog-close]="comment">
      Aceptar
    </button>
  </div>
</div>

<div *ngIf="fees">
  <cgw-purchase-fees [precioLista]="type.data"></cgw-purchase-fees>
</div>

<div *ngIf="deleteQuestion">
  <h2
    mat-dialog-title
    class="orange noMargin">
    Confirmación
  </h2>
  <div mat-dialog-content>
    <p>¿Estás seguro de eliminar la pregunta?</p>
  </div>
  <div
    mat-dialog-actions
    class="button">
    <button
      mat-raised-button
      color="primary"
      class="first"
      [mat-dialog-close]="true">
      Aceptar
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onNoClick()">
      Cancelar
    </button>
  </div>
</div>
<div *ngIf="login">
  <a
    class="pointer closeModal"
    (click)="onNoClick()"
    ><mat-icon>cancel</mat-icon></a
  >
  <cgw-login (returnClose)="returnClose($event)"></cgw-login>
</div>
<div
  *ngIf="sendPass"
  class="center">
  <h2 mat-dialog-title>Recupero de contraseña</h2>
  <mat-dialog-content>
    <p>
      Envíamos un código temporal y los pasos a seguir para cambiar la contraseña a tu correo
      registrado
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-raised-button
      mat-dialog-close
      class="button-ok width-ancho"
      color="primary">
      Aceptar
    </button>
  </mat-dialog-actions>
</div>
<div
  *ngIf="errorTokenTarjeta"
  class="center">
  <h2 mat-dialog-title>Datos Erroneos</h2>
  <div mat-dialog-content>
    <p style="text-align: left">
      Ocurrió un problema con tu pago. Por favor, revisa los datos ingresados.
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      ACEPTAR
    </button>
  </div>
</div>
<div
  *ngIf="errorProcessPayment"
  class="center">
  <h2 mat-dialog-title>Error en el Pago</h2>
  <div mat-dialog-content>
    <p style="text-align: left">
      Ocurrió un error al procesar el pago. No te preocupes porque ya tenés la reserva hecha.
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="false">
      ACEPTAR
    </button>
  </div>
</div>
<div
  *ngIf="successProcessPayment"
  class="center">
  <h2 mat-dialog-title>Pago exitoso</h2>
  <div mat-dialog-content>
    <p style="text-align: left">El pago fue efectuado con éxito.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      ACEPTAR
    </button>
  </div>
</div>

<div
  *ngIf="userExist"
  class="center">
  <h2 mat-dialog-title>Usuario registrado</h2>
  <div mat-dialog-content>
    <p>El correo ingresado ya existe como cliente, por favor iniciá sesión.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="userRegister"
  class="center">
  <h2 mat-dialog-title>Cuenta creada</h2>
  <div mat-dialog-content>
    <p>Tu cuenta se ha creado con éxito. Por favor iniciá sesión con tus datos.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="changePass"
  class="center">
  <h2 mat-dialog-title>Cambio de contraseña</h2>
  <div mat-dialog-content>
    <p>Tu contraseña ha sido correctamente actualizada</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="validarMail"
  class="validarMail">
  <h2
    mat-dialog-title
    class="noMargin title-parrafo">
    Necesitamos que valides tu mail
  </h2>
  <div mat-dialog-content>
    <p class="message-parrafo">
      Te enviamos un mail de verificación a tu casilla, es posible que llegue a la carpeta de correo
      no deseado.
    </p>
  </div>
  <div
    mat-dialog-actions
    class="button">
    <button
      mat-raised-button
      color="primary"
      [mat-dialog-close]="true">
      ACEPTAR
    </button>
  </div>
  <div class="center">
    <p>
      ¿No te llegó el mail?
      <span
        class="link"
        (click)="sendMailAgain()"
        >Volver a enviar</span
      >
    </p>
  </div>
</div>
<div
  *ngIf="errorCompra"
  class="center">
  <h2 mat-dialog-title>Aviso</h2>
  <div mat-dialog-content>
    <p>Hubo un error en la solicitud de compra. Por favor volvé a intentar en unos instantes.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="errorCompraEtiqueta"
  class="center">
  <h2 mat-dialog-title>{{ type.data.aviso?.encabezado }}</h2>
  <div mat-dialog-content>
    <p>{{ ((type.data.aviso?.tarjetas)[0]?.detalle)[0]?.texto }}</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      *ngIf="type.data.aviso?.encabezado === 'Pedidos web en proceso.'"
      [mat-dialog-close]="true">
      IR A MI CUENTA
    </button>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      *ngIf="type.data.aviso?.encabezado !== 'Pedidos web en proceso.'"
      (click)="onNoClick()">
      ACEPTAR
    </button>
  </div>
</div>
<div
  *ngIf="dobleReserva"
  class="center">
  <h2 mat-dialog-title>Pedido pendiente de pago</h2>
  <div mat-dialog-content>
    <p>
      Para poder realizar otra compra podés cancelar tu pedido vigente desde "Mi Cuenta" o esperar a
      que se procese tu pago.
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>

<div
  *ngIf="errorDomicilio"
  class="center">
  <h2 mat-dialog-title>Falta indicar la modalidad de envío</h2>
  <div mat-dialog-content>
    <p>Para finalizar tu pedido, necesitamos que selecciones el método de envío que prefieras.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="errorMedioEnvio"
  class="center">
  <h2 mat-dialog-title>Método de envío inválido</h2>
  <div mat-dialog-content>
    <p>Por favor elegí otro método de envío para poder finalizar la compra.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>

<div
  *ngIf="billing_out"
  class="center">
  <h2 mat-dialog-title>Datos faltantes</h2>
  <div mat-dialog-content>
    <p style="text-align: left">
      Tenés que agregar una cuenta de facturación para continuar tu compra.
    </p>
  </div>
  <button
    mat-raised-button
    color="primary"
    class="button-ok width-ancho mt-2"
    [mat-dialog-close]="true">
    AGREGAR CUENTA
  </button>
  <button
    mat-raised-button
    class="button-cancel-outline mt-2"
    (click)="onNoClick()">
    CANCELAR
  </button>
</div>
<div
  *ngIf="errorNoCuil"
  class="center">
  <h2 mat-dialog-title>Datos faltantes</h2>
  <div mat-dialog-content>
    <p style="text-align: left">Tenés que agregar tu CUIL a tu cuenta de facturación elegida.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      ACEPTAR
    </button>
  </div>
</div>
<div
  *ngIf="errorNoDni"
  class="center">
  <h2 mat-dialog-title>Datos faltantes</h2>
  <div mat-dialog-content>
    <p style="text-align: left">Tenés que agregar tu DNI a tu domicilio de envío elegido.</p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      ACEPTAR
    </button>
  </div>
</div>
<div
  *ngIf="noArmadoService"
  class="center">
  <h2 mat-dialog-title>Si eliminas este elemento no podremos armar tu pc</h2>
  <div mat-dialog-content>
    <p>
      Este elemento es fundamental para el armado del equipo, si lo eliminás procederemos a enviarte
      los componentes restantes del carrito de forma individual.
    </p>
  </div>
  <div
    mat-dialog-actions
    class="flex-column">
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho mb-3"
      [mat-dialog-close]="true">
      ELIMINAR COMPONENTE
    </button>
    <button
      mat-raised-button
      class="m-0 button-cancel-outline"
      (click)="onNoClick()">
      CANCELAR
    </button>
  </div>
</div>
<div *ngIf="loadingBloq">
  <cgw-spinner></cgw-spinner>
</div>
<div
  *ngIf="dobleMail"
  class="center">
  <h2 mat-dialog-title>Error al ingresar</h2>
  <div mat-dialog-content>
    <p>
      Tu correo principal es <b>{{ type.data }}</b
      >. Si querés hacerte una cuenta con este email tenés que entrar con {{ type.data }} y borrarlo
      desde la seccion "Mi cuenta".
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="cuentaMismoDoc"
  class="center">
  <h2 mat-dialog-title>Error al registrar cuenta</h2>
  <div mat-dialog-content>
    <p>
      Ya tenes una cuenta de facturación registrada con el número de documento ingresado. Verificá
      los datos e intentá nuevamente
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="verificacion"
  class="center">
  <div mat-dialog-content>
    <div class="pasos__content-imagen">
      <img
        class="img"
        [src]="verificacionPaso"
        [alt]="verificacionPaso" />
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div
  *ngIf="informacion"
  class="center informacion-tjt">
  <div mat-dialog-content>
    <p class="titulo">¡Importante!</p>
    <p>
      Desde Compra Gamer nunca te vamos a pedir el número completo o el código de seguridad de tu
      tarjeta, a la hora de tomar las fotos asegurate de seguir paso a paso las indicaciones
      brindadas para que estos datos queden ocultos.
    </p>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div *ngIf="precioEspecial">
  <div class="center">
    <div mat-dialog-content>
      <p class="titulo">Precio Especial</p>
      <p>Pagando por depósito o transferencia bancaria</p>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      (click)="onNoClick()">
      Aceptar
    </button>
  </div>
</div>
<div *ngIf="this.type.type == 'errorMonto'">
  <div class="center">
    <div mat-dialog-content>
      <p class="titulo_monto">Ya tenés tu reserva hecha pero tu pago no fue realizado</p>
      <p class="descripcion_monto">
        <b>El pago aún no fue ingresado en tu tarjeta,</b> ya que hay productos que variaron su
        precio. Te pedimos que verifiques el detalle desde la reserva.
        <b>Desde “Mi cuenta” podrás completar el pago correctamente.</b>
      </p>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      class="button-ok width-ancho"
      [mat-dialog-close]="true">
      pagar desde mi cuenta
    </button>
  </div>
</div>
